import React from "react";
import Back from "../icons/back.svg?react";
import Barcode from "../icons/barcode.svg?react";
import Breakfast from "../icons/breakfast.svg?react";
import Calculator from "../icons/abacus.svg?react";
import Calendar from "../icons/calendar.svg?react";
import Cancel from "../icons/cancel.svg?react";
import Check from "../icons/check.svg?react";
import Chain from "../icons/chain.svg?react";
import ClipboardImage from "../icons/clipboard-image.svg?react";
import Cook from "../icons/cook.svg?react";
import CopyValues from "../icons/copy-values.svg?react";
import Day from "../icons/calendar-day.svg?react";
import Delete from "../icons/delete.svg?react";
import Dinner from "../icons/dinner.svg?react";
import Dish from "../icons/dish.svg?react";
import DotsHorizontal from "../icons/dots-horizontal.svg?react";
import FastIntake from "../icons/fast-intake.svg?react";
import FilterRemove from "../icons/filter-remove.svg?react";
import Food from "../icons/food.svg?react";
import Forward from "../icons/forward.svg?react";
import Gear from "../icons/gear.svg?react";
import History from "../icons/history.svg?react";
import Intake from "../icons/intake.svg?react";
import Keto from "../icons/keto.svg?react";
import LowCarb from "../icons/low-carb.svg?react";
import LowFat from "../icons/low-fat.svg?react";
import Lunch from "../icons/lunch.svg?react";
import MealPlan from "../icons/meal-plan.svg?react";
import Next from "../icons/next.svg?react";
import Pencil from "../icons/pencil.svg?react";
import PinDestination from "../icons/pin-destination.svg?react";
import Plus from "../icons/plus-circle.svg?react";
import Purchase from "../icons/purchase.svg?react";
import Restriction from "../icons/restriction.svg?react";
import ShopCart from "../icons/shop-cart.svg?react";
import Snack from "../icons/snack.svg?react";
import SplitValues from "../icons/split-values.svg?react";
import Store from "../icons/store.svg?react";
import Today from "../icons/calendar-today.svg?react";
import Undo from "../icons/undo.svg?react";
import Unit from "../icons/unit.svg?react";
import Unit_1 from "../icons/unit_1.svg?react";
import Unit_100 from "../icons/unit_100.svg?react";
import Banana from "../icons/banana.svg?react";
import Cheese from "../icons/cheese.svg?react";
import IceCreamCone from "../icons/ice-cream-cone.svg?react";
import JamJar from "../icons/jam-jar.svg?react";
import Jug from "../icons/jug.svg?react";
import PizzaSlice from "../icons/pizza-slice.svg?react";
import Popcorn from "../icons/popcorn.svg?react";
import Sausage from "../icons/sausage.svg?react";
import TeaCoffee from "../icons/tea-coffee.svg?react";
import WineBottleGlass from "../icons/wine-bottle-glass.svg?react";
import ChickenLeg from "../icons/chicken-leg.svg?react";
import Cupcake from "../icons/cupcake.svg?react";
import HerbMix from "../icons/herb-mix.svg?react";
import Leaf from "../icons/leaf.svg?react";
import PlantHeart from "../icons/plant-heart.svg?react";
import SauceBottle from "../icons/sauce-bottle.svg?react";
import Turnip from "../icons/turnip.svg?react";
import Warning from "../icons/warning.svg?react";
import Wheat from "../icons/wheat.svg?react";
import MagicWandSparkles from "../icons/magic-wand-sparkles.svg?react";
import ViewArrow from "../icons/view-arrow.svg?react";
import AccountArrows from "../icons/account-arrows.svg?react";
import Star from "../icons/star.svg?react";
import Account from "../icons/account.svg?react";
import AtEmail from "../icons/at-email.svg?react";
import AtHorizontalSliderDots from "../icons/at-horizontal-sliders-dots.svg?react";
import AtListReceipt from "../icons/at-list-receipt.svg?react";
import Search from "../icons/search.svg?react";
import Reassign from "../icons/reassign.svg?react";

export const plan2plateIcons = {
  account: <Account />,
  accountArrows: <AccountArrows />,
  atEmail: <AtEmail />,
  atHorizontalSliderDots: <AtHorizontalSliderDots />,
  atListReceipt: <AtListReceipt />,
  back: <Back />,
  banana: <Banana />,
  barcode: <Barcode />,
  breakfast: <Breakfast />,
  calculator: <Calculator />,
  calendar: <Calendar />,
  cancel: <Cancel />,
  check: <Check />,
  chain: <Chain />,
  cheese: <Cheese />,
  chickenLeg: <ChickenLeg />,
  clipboardImage: <ClipboardImage />,
  cook: <Cook />,
  copyValues: <CopyValues />,
  cupcake: <Cupcake />,
  day: <Day />,
  delete: <Delete />,
  dinner: <Dinner />,
  dish: <Dish />,
  dotsHorizontal: <DotsHorizontal />,
  fastIntake: <FastIntake />,
  filterRemove: <FilterRemove />,
  food: <Food />,
  forward: <Forward />,
  gear: <Gear />,
  herbMix: <HerbMix />,
  history: <History />,
  iceCreamCone: <IceCreamCone />,
  intake: <Intake />,
  jamJar: <JamJar />,
  jug: <Jug />,
  keto: <Keto />,
  leaf: <Leaf />,
  lowCarb: <LowCarb />,
  lowFat: <LowFat />,
  lunch: <Lunch />,
  magicWandSparkles: <MagicWandSparkles />,
  mealPlan: <MealPlan />,
  next: <Next />,
  pencil: <Pencil />,
  pinDestination: <PinDestination />,
  pizzaSlice: <PizzaSlice />,
  plantHeart: <PlantHeart />,
  plus: <Plus />,
  popcorn: <Popcorn />,
  purchase: <Purchase />,
  reassign: <Reassign />,
  restriction: <Restriction />,
  sauceBottle: <SauceBottle />,
  sausage: <Sausage />,
  search: <Search />,
  shopCart: <ShopCart />,
  snack: <Snack />,
  splitValues: <SplitValues />,
  star: <Star />,
  store: <Store />,
  teaCoffee: <TeaCoffee />,
  today: <Today />,
  turnip: <Turnip />,
  undo: <Undo />,
  unit: <Unit />,
  unit_1: <Unit_1 />,
  unit_100: <Unit_100 />,
  viewArrow: <ViewArrow />,
  warning: <Warning />,
  wheat: <Wheat />,
  wineBottleGlass: <WineBottleGlass />,
};
